import { render, staticRenderFns } from "./NotificationToast.vue?vue&type=template&id=8e5b5d60&scoped=true&"
import script from "./NotificationToast.vue?vue&type=script&lang=js&"
export * from "./NotificationToast.vue?vue&type=script&lang=js&"
import style0 from "./NotificationToast.vue?vue&type=style&index=0&id=8e5b5d60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5b5d60",
  null
  
)

export default component.exports